import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { useForm, useWatch, useFieldArray } from "react-hook-form";
import { useSelector } from "react-redux";
import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import RemoveIcon from '@mui/icons-material/HighlightOff';
import ButtonWrapper from "../../components/Button";
import {
    genderData,
    yesOrNo,
    propertyTypeListUP,
    ownerOrApplicant,
    schemeNameList
} from "../../data";
import InputContainer from "../../layout/inputContainer";
import useDepartmentSelector from "../../hooks/useDepartmentSelector";
import Address from "./Address";
import FileUploader from "../MobileTowerApplication/FileUploader";
import { accordionSummaryStyles } from "../../forms/StyledComponents";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";

const Step1 = ({ formData, isUpdating, handleTabChange }) => {
    const { documents } = useSelector(state => state.formMT);
    const [isUdFlow, applicationFlow, DepartmentSelector] = useDepartmentSelector();
    const { t } = useTranslation()
    const ownerEntry = {
        name: '',
        fatherOrHusbandName: '',
        mobileNumber: '',
        emailId: '',
        aadhaarNumber: '',
        gender: null,
        correspondenceAddress: {
            applicantName: null,
            applicantGuardianName: null,
            state: "Uttar Pradesh",
            district: null,
            tehsil: null,
            town: null,
            address: "",
            pinno: "",
            type: "CORRESPONDENCE",
        },
        permanentAddress: {
            applicantName: null,
            applicantGuardianName: null,
            state: "Uttar Pradesh",
            district: null,
            tehsil: null,
            town: null,
            address: "",
            pinno: "",
            type: "PERMANENT",
        },
    };
    const propertyEntry = {
        sectorNo: null,
        propertyNo: null,
        schemeName: null,
        block: null,
        khataNo: null,
        khasraNo: null,
        khatauniNo: null,
        plotArea: 0,
        plotNo: null,
        roadWidth: null,
        appliedLandUse: {
            name: null,
        },
        propertyType: {
            name: null,
        },
        propertyAddress: {
            address: null,
            state: null,
            pinno: null,
            district: null
        }
    };
    const defaultValues = {
        ...formData,
        documents,
        landInfo: {
            ...formData?.landInfo,
            owners: formData?.landInfo?.owners?.length > 0 ? formData?.landInfo?.owners : [ownerEntry]
        },
        descriptionOfLand: {
            ...formData?.descriptionOfLand,
            properties: formData?.descriptionOfLand?.properties?.length > 0 ? formData?.descriptionOfLand?.properties : [propertyEntry]
        }
    };
    const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });

    useEffect(() => {
        setValue('documents', documents);
    }, [documents]);

    const watchApprovedLayout = watch('approvedLayout') === 'yes'
    const watchownerOrApplicant = watch('ownerOrApplicant') === 'Applicant'
    const morethanOneOwner = watch('morethanOneOwner') === 'yes'
    const morethanOneProperty = watch('morethanOneProperty') === 'yes'

    const { fields: owners, append: appendOwner, remove: removeOwner } = useFieldArray({
        control,
        name: "landInfo.owners",
    });
    const { fields: properties, append: appendProp, remove: removeProp } = useFieldArray({
        control,
        name: "descriptionOfLand.properties",
    });


    const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
    const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"))

    const onSubmit = (data) => {
        handleTabChange(1, data)
    };

    if (applicationFlow === null) {
        return <DepartmentSelector />;
    }
    return (
        <section className="container1" style={{ marginTop: 0 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer">
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                            <div className="formHeaderContainer">
                                <h2 className="formHeading">{t('Basic Information')}</h2>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="formInputContainer">
                                <div className="columnWrapper">
                                    <InputContainer
                                        control={control}
                                        label={`${t("Are You the Owner or Applicant")}`}
                                        defaultValue={formData?.ownerOrApplicant}
                                        name={`ownerOrApplicant`}
                                        type="radioButton"
                                        data={ownerOrApplicant}
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "Please select the gender",
                                            },
                                        }}
                                    />
                                    <InputContainer
                                        control={control}
                                        label={`${t("Is Your Property Part of Approved Layout")}`}
                                        placeholder="approvedLayout"
                                        defaultValue={formData?.approvedLayout}
                                        name={`approvedLayout`}
                                        type="radioButton"
                                        data={yesOrNo}
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "Please select the gender",
                                            },
                                        }}
                                    />
                                </div>
                                <div className="columnWrapper">
                                    <InputContainer
                                        control={control}
                                        label={`${t("Is More than One Owner")}`}
                                        defaultValue={formData?.morethanOneOwner}
                                        name={`morethanOneOwner`}
                                        type="radioButton"
                                        data={yesOrNo}
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "Please select the gender",
                                            },
                                        }}
                                    />
                                    <InputContainer
                                        control={control}
                                        label={`${t("Is More than One Property")}`}
                                        defaultValue={formData?.morethanOneProperty}
                                        name={`morethanOneProperty`}
                                        type="radioButton"
                                        data={yesOrNo}
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "Please select the gender",
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </AccordionDetails>
                    </Accordion>

                </div>

                {watchownerOrApplicant && <div className="formContainer">
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                            <div className="formHeaderContainer">
                                <h2 className="formHeading">Applicant Information</h2>
                            </div>
                        </AccordionSummary>

                        <AccordionDetails>
                            <div className="formInputContainer">
                                <div className="columnWrapper">
                                    <InputContainer
                                        label={t("LABEL_ENTER_NAME")}
                                        control={control}
                                        placeholder={t("LABEL_ENTER_NAME")}
                                        defaultValue={formData?.applicant?.name}
                                        name='applicant.name'
                                        type="textInput"
                                        maxLength={30}
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern("Name"),
                                                message: "Please enter only letters and spaces",
                                            },
                                        }}
                                    />
                                    <InputContainer
                                        label={t("LABEL_EMAIL_ID")}
                                        control={control}
                                        placeholder={t("LABEL_ENTER_EMAIL_ID")}
                                        defaultValue={formData?.applicant?.emailId}
                                        name={`applicant.emailId`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern("Email"),
                                                message: "Please enter valid email id",
                                            },
                                        }}
                                    />
                                    <FileUploader
                                        control={control}
                                        name="authorization Letter"
                                        label={t("Authorization Letter")}
                                        validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                                        isMandatory
                                        required
                                        tab={1}
                                    />
                                </div>
                                <div className="columnWrapper">
                                    <InputContainer
                                        control={control}
                                        label={t("LABEL_ADDRESS")}
                                        placeholder={t("LABEL_ENTER_ADDRESS")}
                                        defaultValue={formData?.applicant?.address}
                                        name={`applicant.address`}
                                        type="textInput"
                                        mandatory
                                        multiLine
                                        maxLength={150}
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern('Address'),
                                                message: "Please enter valid Address",
                                            },
                                        }}
                                    />
                                    <InputContainer
                                        control={control}
                                        label="Mobile Number(As in Aadhaar)"
                                        placeholder={t("LABEL_ENTER_MOBILE_NO")}
                                        defaultValue={formData?.applicant?.mobileNumber}
                                        name={`applicant.mobileNumber`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern("MobileNo"),
                                                message: "Please enter valid mobile no",
                                            },
                                        }}
                                        maxLength={10}
                                    />
                                    <InputContainer
                                        label={t("LABEL_AADHAAR_NUMBER")}
                                        control={control}
                                        placeholder={t("LABEL_ENTER_AADHAAR_NO")}
                                        defaultValue={formData?.applicant?.aadhaarNumber}
                                        name={`applicant.aadhaarNumber`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            pattern: {
                                                value: Digit.Utils.getPattern("AadharNo"),
                                                message: "Please enter valid Aadhaar no",
                                            },
                                        }}
                                        maxLength={12}
                                    />
                                </div>
                                <br />
                            </div>

                        </AccordionDetails>
                    </Accordion>
                </div>}

                <div className="formContainer">
                    {owners?.map((owner, index) => (
                        <Accordion defaultExpanded>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                                <div className="formHeaderContainer">
                                    <h2 className="formHeading">{index > 0 ? t("Additional Owner Information"): t("Owner Information")} </h2>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="formInputContainer" key={owner.id}>
                                    <div className="columnWrapper">
                                        <InputContainer
                                            label={t("LABEL_ENTER_NAME")}
                                            control={control}
                                            placeholder={t("LABEL_ENTER_NAME")}
                                            defaultValue={owner.name}
                                            name={`landInfo.owners[${index}].name`}
                                            type="textInput"
                                            maxLength={30}
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required",
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern("Name"),
                                                    message: "Please enter only letters and spaces",
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            label={t("LABEL_GENDER")}
                                            placeholder="Gender"
                                            defaultValue={owner.gender}
                                            name={`landInfo.owners[${index}].gender`}
                                            type="selectInput"
                                            data={genderData}
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "Please select the gender",
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            label={t("LABEL_EMAIL_ID")}
                                            control={control}
                                            placeholder={t("LABEL_ENTER_EMAIL_ID")}
                                            defaultValue={owner.emailId}
                                            name={`landInfo.owners[${index}].emailId`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required",
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern("Email"),
                                                    message: "Please enter valid email id",
                                                },
                                            }}
                                        />
                                        <FileUploader
                                            control={control}
                                            name={`applicantPhoto[${index}]`}
                                            label={t("LABEL_OWNER_PHOTO")}
                                            validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                                            isMandatory
                                            required
                                            tab={1}
                                        />
                                        {/* <Grid container spacing={2}>
                                        <Grid item xs={6} md={3}>{t('Communication Address')}</Grid>
                                        </Grid> */}
                                        <InputContainer
                                            control={control}
                                            label={t("LABEL_ADDRESS")}
                                            placeholder={t("LABEL_ENTER_ADDRESS")}
                                            defaultValue={owner.correspondenceAddress.address}
                                            name={`landInfo.owners[${index}].correspondenceAddress.address`}
                                            type="textInput"
                                            mandatory
                                            multiLine
                                            maxLength={150}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern('Address'),
                                                    message: "Please enter valid Address",
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            data={updistricts}
                                            label={t("LABEL_CITY")}
                                            placeholder={t("LABEL_ENTER_CITY")}
                                            defaultValue={owner.correspondenceAddress.district}
                                            name={`landInfo.owners[${index}].correspondenceAddress.district`}
                                            type="selectInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="columnWrapper">
                                        <InputContainer
                                            control={control}
                                            label={t("LABEL_FATHERS_NAME")}
                                            placeholder={t("LABEL_ENTER_FATHERS_NAME")}
                                            defaultValue={owner.fatherOrHusbandName}
                                            name={`landInfo.owners[${index}].fatherOrHusbandName`}
                                            type="textInput"
                                            maxLength={30}
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required",
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern("Name"),
                                                    message: "Please enter only letters and spaces",
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            label="Mobile Number(As in Aadhaar)"
                                            placeholder={t("LABEL_ENTER_MOBILE_NO")}
                                            defaultValue={owner.mobileNumber}
                                            name={`landInfo.owners[${index}].mobileNumber`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required",
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern("MobileNo"),
                                                    message: "Please enter valid mobile no",
                                                },
                                            }}
                                            maxLength={10}
                                        />
                                        <InputContainer
                                            label={t("LABEL_AADHAAR_NUMBER")}
                                            control={control}
                                            placeholder={t("LABEL_ENTER_AADHAAR_NO")}
                                            defaultValue={owner.aadhaarNumber}
                                            name={`landInfo.owners[${index}].aadhaarNumber`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                pattern: {
                                                    value: Digit.Utils.getPattern("AadharNo"),
                                                    message: "Please enter valid Aadhaar no",
                                                },
                                            }}
                                            maxLength={12}
                                        />
                                        <FileUploader
                                            control={control}
                                            name={`signature[${index}]`}
                                            label={t("LABEL_SIGNATURE")}
                                            validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                                            isMandatory
                                            required
                                            tab={1}
                                        />
                                        <InputContainer
                                            control={control}
                                            label={t("LABEL_STATE")}
                                            defaultValue={owner.correspondenceAddress.state || t("LABEL_STATE_UP")}
                                            name={`landInfo.owners[${index}].correspondenceAddress.state`}
                                            type="textInput"
                                            disabled
                                        />
                                        <InputContainer
                                            control={control}
                                            label={t("LABEL_PINCODE")}
                                            placeholder={t("LABEL_ENTER_PINCODE")}
                                            defaultValue={owner.correspondenceAddress.pinno}
                                            name={`landInfo.owners[${index}].correspondenceAddress.pinno`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern('Pincode'),
                                                    message: "Please enter valid Pincode",
                                                },
                                            }}
                                            maxLength={6}
                                        />
                                        {morethanOneOwner && <Box sx={{ display: 'flex', gap: '.5rem', justifyContent: 'flex-end' }}>
                                            <IconButton color="primary" aria-label="Add more" onClick={() => appendOwner(ownerEntry)}>
                                                <AddIcon sx={{ width: '24px', height: '24px' }} />
                                            </IconButton>
                                            {owners.length > 0 && index > 0 && (
                                                <IconButton color="error" aria-label="Delete" onClick={() => removeOwner(index)}>
                                                    <RemoveIcon sx={{ width: '24px', height: '24px' }} />
                                                </IconButton>
                                            )}
                                        </Box>}
                                    </div>
                                    <br />
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>
                {!watchApprovedLayout && <div className="formContainer">
                    {properties?.map((property, index) => (
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                                <div className="formHeaderContainer">
                                    <h2 className="formHeading">
                                    {index > 0 ? t("Additional Registration Information"): t("Registration Information")}                                    </h2>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="formInputContainer">
                                    <div className="columnWrapper">
                                        <InputContainer
                                            label={t("LABEL_KHASRA_NO")}
                                            control={control}
                                            placeholder={t("LABEL_ENTER_KHASRA_NO")}
                                            defaultValue={property.khasraNo}
                                            name={`descriptionOfLand.properties[${index}].khasraNo`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            label={t("LABEL_KHATA_NO")}
                                            control={control}
                                            placeholder={t("LABEL_ENTER_KHATA_NO")}
                                            defaultValue={property.khataNo}
                                            name={`descriptionOfLand.properties[${index}].khataNo`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            label="Plot Area"
                                            control={control}
                                            placeholder="Enter Plot Area"
                                            defaultValue={property.plotArea}
                                            name={`descriptionOfLand.properties[${index}].plotArea`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            label="Land use as per master plan"
                                            control={control}
                                            placeholder="Enter Land use as per master plan"
                                            defaultValue={property.appliedLandUse.name}
                                            name={`descriptionOfLand.properties[${index}].appliedLandUse.name`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            label="Scheme Name"
                                            control={control}
                                            placeholder="Select Scheme Name"
                                            defaultValue={property.schemeName}
                                            name={`descriptionOfLand.properties[${index}].schemeName`}
                                            type="selectInput"
                                            mandatory
                                            data={schemeNameList}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            label={t("LABEL_ADDRESS")}
                                            placeholder={t("LABEL_ENTER_ADDRESS")}
                                            defaultValue={property.propertyAddress.address}
                                            name={`descriptionOfLand.properties[${index}].propertyAddress.address`}
                                            type="textInput"
                                            mandatory
                                            multiLine
                                            maxLength={150}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern('Address'),
                                                    message: "Please enter valid Address",
                                                },
                                            }}
                                        />
                                    </div>
                                    <div className="columnWrapper">
                                        <InputContainer
                                            label="Khatuni No."
                                            control={control}
                                            placeholder="Enter Khatuni No."
                                            defaultValue={property.khatauniNo}
                                            name={`descriptionOfLand.properties[${index}].khatauniNo`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            label={t("LABEL_PLOT_NO")}
                                            control={control}
                                            placeholder={t("LABEL_ENTER_PLOT_NO")}
                                            defaultValue={property.plotNo}
                                            name={`descriptionOfLand.properties[${index}].plotNo`}
                                            type="textInput"
                                            maxLength={10}
                                        />
                                        <InputContainer
                                            label="Road Width"
                                            control={control}
                                            placeholder="Enter Road Width"
                                            defaultValue={property.roadWidth}
                                            name={`descriptionOfLand.properties[${index}].roadWidth`}
                                            type="textInput"
                                            mandatory
                                            //maxLength={10}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            data={updistricts}
                                            label={t("LABEL_CITY")}
                                            placeholder={t("LABEL_ENTER_CITY")}
                                            defaultValue={property.city}
                                            name={`descriptionOfLand.properties[${index}].city`}
                                            type="selectInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                }
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            label={t("LABEL_STATE")}
                                            defaultValue={property.propertyAddress.state || t("LABEL_STATE_UP")}
                                            name={`descriptionOfLand.properties[${index}].propertyAddress.state`}
                                            type="textInput"
                                            disabled
                                        />
                                        <InputContainer
                                            control={control}
                                            label={t("LABEL_PINCODE")}
                                            placeholder={t("LABEL_ENTER_PINCODE")}
                                            defaultValue={property.propertyAddress.pinno}
                                            name={`descriptionOfLand.properties[${index}].propertyAddress.pinno`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern('Pincode'),
                                                    message: "Please enter valid Pincode",
                                                },
                                            }}
                                            maxLength={6}
                                        />
                                        {morethanOneProperty && <Box sx={{ display: 'flex', gap: '.5rem', justifyContent: 'flex-end' }}>
                                            <IconButton color="primary" aria-label="Add more" onClick={() => appendProp(propertyEntry)}>
                                                <AddIcon sx={{ width: '24px', height: '24px' }} />
                                            </IconButton>
                                            {owners.length > 0 && index > 0 && (
                                                <IconButton color="error" aria-label="Delete" onClick={() => removeProp(index)}>
                                                    <RemoveIcon sx={{ width: '24px', height: '24px' }} />
                                                </IconButton>
                                            )}
                                        </Box>}
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>}
                {watchApprovedLayout && <div className="formContainer">
                    {properties?.map((property, index) => (
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                                <div className="formHeaderContainer">
                                    <h2 className="formHeading">
                                    {index > 0 ? t("Additional Registration Information"): t("Registration Information")}                                    
                                    </h2>                              
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="formInputContainer">
                                    <div className="columnWrapper">
                                        <InputContainer
                                            label="Property Type"
                                            control={control}
                                            placeholder="Select Property Type"
                                            defaultValue={property.propertyType.name}
                                            name={`descriptionOfLand.properties[${index}].propertyType.name`}
                                            type="selectInput"
                                            mandatory
                                            data={propertyTypeListUP}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            label="Sector No."
                                            defaultValue={property.sectorNo}
                                            name={`descriptionOfLand.properties[${index}].sectorNo`}
                                            type="textInput"
                                            placeholder={"Enter Sector No."}
                                            mandatory
                                            maxLength={30}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            label="Property Number"
                                            defaultValue={property.propertyNo}
                                            name={`descriptionOfLand.properties[${index}].propertyNo`}
                                            type="textInput"
                                            placeholder={"Enter Property No."}
                                            maxLength={30}
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            label="Plot Area(As per Allotment Letter)"
                                            control={control}
                                            placeholder="Enter Plot Area"
                                            defaultValue={property.plotArea}
                                            name={`descriptionOfLand.properties[${index}].plotArea`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required",
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            label={t("LABEL_ADDRESS")}
                                            placeholder={t("LABEL_ENTER_ADDRESS")}
                                            defaultValue={property.propertyAddress.address}
                                            name={`descriptionOfLand.properties[${index}].propertyAddress.address`}
                                            type="textInput"
                                            mandatory
                                            multiLine
                                            maxLength={150}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern('Address'),
                                                    message: "Please enter valid Address",
                                                },
                                            }}
                                        />
                                    </div>
                                    <div className="columnWrapper">
                                        <InputContainer
                                            label="Property land use (as in allotment letter)"
                                            control={control}
                                            placeholder="Enter Land use as per master plan"
                                            defaultValue={property.appliedLandUse.name}
                                            name={`descriptionOfLand.properties[${index}].appliedLandUse.name`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            label="Scheme Name"
                                            control={control}
                                            placeholder="Select Scheme Name"
                                            defaultValue={property.schemeName}
                                            name={`descriptionOfLand.properties[${index}].schemeName`}
                                            type="selectInput"
                                            mandatory
                                            data={schemeNameList}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            label="Block"
                                            placeholder={"Enter Block"}
                                            defaultValue={property.block}
                                            name={`descriptionOfLand.properties[${index}].block`}
                                            type="textInput"
                                            mandatory
                                            maxLength={30}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            data={updistricts}
                                            label={t("LABEL_CITY")}
                                            placeholder={t("LABEL_ENTER_CITY")}
                                            defaultValue={property.city}
                                            name={`descriptionOfLand.properties[${index}].city`}
                                            type="selectInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                }
                                            }}
                                        />
                                        <InputContainer
                                            control={control}
                                            label={t("LABEL_STATE")}
                                            defaultValue={property.propertyAddress.state || t("LABEL_STATE_UP")}
                                            name={`descriptionOfLand.properties[${index}].propertyAddress.state`}
                                            type="textInput"
                                            disabled
                                        />
                                        <InputContainer
                                            control={control}
                                            label={t("LABEL_PINCODE")}
                                            placeholder={t("LABEL_ENTER_PINCODE")}
                                            defaultValue={property.propertyAddress.pinno}
                                            name={`descriptionOfLand.properties[${index}].propertyAddress.pinno`}
                                            type="textInput"
                                            mandatory
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern('Pincode'),
                                                    message: "Please enter valid Pincode",
                                                },
                                            }}
                                            maxLength={6}
                                        />
                                        {morethanOneProperty && <Box sx={{ display: 'flex', gap: '.5rem', justifyContent: 'flex-end' }}>
                                            <IconButton color="primary" aria-label="Add more" onClick={() => appendProp(propertyEntry)}>
                                                <AddIcon sx={{ width: '24px', height: '24px' }} />
                                            </IconButton>
                                            {owners.length > 0 && index > 0 && (
                                                <IconButton color="error" aria-label="Delete" onClick={() => removeProp(index)}>
                                                    <RemoveIcon sx={{ width: '24px', height: '24px' }} />
                                                </IconButton>
                                            )}
                                        </Box>}
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>}

                {/* <div className="formContainer">
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                            <div className="formHeaderContainer">
                                <h2 className="formHeading">Address Details</h2>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="formInputContainer">
                                <Address {...{
                                    defaultValues: formData?.landInfo?.owners?.[0]?.correspondenceAddress,
                                    namePrefix: 'landInfo.owners[0].correspondenceAddress',
                                    nameKeyPrefix: 'landInfo.owners[0]',
                                    applicationFlow,
                                    setValue,
                                    control,
                                    watch,
                                    t
                                }} />
                                <Address {...{
                                    defaultValues: formData?.landInfo?.owners?.[0]?.permanentAddress,
                                    namePrefix: 'landInfo.owners[0].permanentAddress',
                                    nameKeyPrefix: 'landInfo.owners[0]',
                                    applicationFlow,
                                    setValue,
                                    control,
                                    watch,
                                    t
                                }} />
                            </div>
                        </AccordionDetails>
                    </Accordion>

                </div> */}

                <div className="formContainer">
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                            <div className="formHeaderContainer">
                                <h2 className="formHeading">
                                    Bank Information(In case of Refund)
                                </h2>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="formInputContainer">
                                <div className="columnWrapper">
                                    <InputContainer
                                        label="Account holder Name"
                                        control={control}
                                        placeholder="Enter Account holder Name"
                                        defaultValue={formData?.landInfo?.bankdetails?.accountHolderName}
                                        name={`landInfo.bankdetails.accountHolderName`}
                                        type="textInput"
                                        maxLength={30}
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern("Name"),
                                                message: "Please enter only letters and spaces",
                                            },
                                        }}
                                    />
                                    <InputContainer
                                        label="Branch Name"
                                        control={control}
                                        placeholder="Enter Branch Name"
                                        defaultValue={formData?.landInfo?.bankdetails?.branchName}
                                        name={`landInfo.bankdetails.branchName`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                        }}
                                    />
                                    <InputContainer
                                        label="IFSC Code"
                                        control={control}
                                        placeholder="Enter IFSC Code"
                                        defaultValue={formData?.landInfo?.bankdetails?.ifscCode}
                                        name={`landInfo.bankdetails.ifscCode`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                        }}
                                    />
                                </div>
                                <div className="columnWrapper">
                                    <InputContainer
                                        label="Account No."
                                        control={control}
                                        placeholder="Enter Account No."
                                        defaultValue={formData?.landInfo?.bankdetails?.accountNo}
                                        name={`landInfo.bankdetails.accountNo`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            }
                                        }}
                                    />
                                    <InputContainer
                                        label={t("LABEL_BANK_NAME")}
                                        control={control}
                                        placeholder={t("LABEL_ENTER_BANK_NAME")}
                                        defaultValue={formData?.landInfo?.bankdetails?.bankName}
                                        name={`landInfo.bankdetails.bankName`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                        }}
                                    />
                                </div>
                                <br />
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>

                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Save and Continue"
                            type="submit"
                            disabled={isUpdating}
                        />
                        <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Reset"
                            onClick={() => reset()}
                        />
                    </div>
                </div>
            </form>
        </section>
    );
};

export default Step1;
